import get from 'lodash/get'
import moment from 'moment'
import React from 'react'
import { Query } from 'react-apollo'
import Loader from '../../../common/loader/Loader'
import Select from '../../../common/select/Select'
import { i18n } from '../../index'
import withActiveStation from '../../station/withActiveStation'
import { getEmployeeSelectorOptions, getThumbsUpSelectorOptions } from '../utils'
import IndexSection from './IndexSection'
import MonthDisplay from './MonthDisplay'
import css from './thumbsUp.css'
import ThumbsUpGraph from './ThumbsUpGraph'
import { fetchEmployeesList, fetchMonthlyThumbsUpReport, thumbsUpItemsQuery } from './ThumbsUpQueries'
import ThumbsUpTable from './ThumbsUpTable'
type Props = {
  activeStation: any
}
type State = {
  selectedDate: moment.Moment
  employeeId: string
  selectedItem: string | null | undefined
}

@withActiveStation
class ThumbsUp extends React.Component<Props, State> {
  state = {
    selectedDate: moment(),
    selectedItem: undefined,
    employeeId: '',
  }
  onMonthChange = (step: number) => {
    this.setState((prevState) => ({
      selectedDate: prevState.selectedDate.add(step, 'months'),
    }))
  }
  onChangeEmployee = (option: any) => {
    this.setState({
      employeeId: option.value,
    })
  }
  onChangeItem = (option: any) => {
    this.setState({
      selectedItem: option.value,
    })
  }

  render() {
    const { activeStation } = this.props
    const { selectedDate, selectedItem, employeeId } = this.state
    const monthName = moment(selectedDate).format('MMMM')
    const monthNumber = +moment(selectedDate).format('MM')
    const year = +moment(selectedDate).format('YYYY')
    return (
      <React.Fragment>
        <div className={css.dropdownContainer}>
          <Query
            query={fetchEmployeesList}
            variables={{
              stationId: activeStation && activeStation.id,
            }}
          >
            {({ loading, data, error }) => {
              const employees = get(data, 'employees.edges', [])
              return (
                <div className={css.dropdown}>
                  <span className={css.label}>{i18n.t('reporting.chooseEmployee')}</span>
                  <Select
                    className={css.select}
                    options={getEmployeeSelectorOptions(employees, 'userId')}
                    onChange={this.onChangeEmployee}
                    value={employeeId}
                  />
                </div>
              )
            }}
          </Query>
          <Query
            query={thumbsUpItemsQuery}
            fetchPolicy='network-only'
            variables={{
              stationId: activeStation && activeStation.id,
              year: year,
              month: monthNumber,
            }}
          >
            {({ loading, data, error }) => {
              const items = get(data, 'monthlyThumbsUpItems', [])
              return (
                <div>
                  <span className={css.label}>{i18n.t('reporting.chooseService')}</span>
                  <Select
                    className={css.select}
                    options={getThumbsUpSelectorOptions(items)}
                    onChange={this.onChangeItem}
                    value={selectedItem}
                  />
                </div>
              )
            }}
          </Query>
        </div>

        <Query
          query={fetchMonthlyThumbsUpReport}
          variables={{
            stationId: activeStation && activeStation.id,
            userId: employeeId,
            thumbsUpItemId: selectedItem,
            year: year,
            month: monthNumber,
          }}
        >
          {({ loading, error, data }) => {
            const reportData = get(data, 'reportMonthlyThumbsUp', [])
            return (
              <Loader
                {...{
                  loading,
                  error,
                }}
              >
                <IndexSection data={reportData} />
                <MonthDisplay selectedMonth={`${monthName} ${year}`} onMonthChange={this.onMonthChange} />
                <ThumbsUpTable data={reportData} year={Number(year)} />
                <ThumbsUpGraph data={reportData} month={selectedDate} />
              </Loader>
            )
          }}
        </Query>
      </React.Fragment>
    )
  }
}

export default ThumbsUp
